module.exports = __webpack_public_path__ + "img/sketch.f7c0bac0.svg";